
import React, { useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { GetBanner, HomeBannerimage_3 } from "../../client-api/ApiHomeBanner";
import { Bannerimages } from "../../Icons/Reuseheading";
import { GetBlog } from "../../client-api/ApiHome";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import moment from "moment";
import Otherproducts from "../Productbycategory/Otherproducts";

const convertToSlug = (text) => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, "")
    .replace(/ +/g, "-");
};

const WhyChooseUs = () => {
  const features = [
   
    "Trusted By Experts",
   

    "Trusted local expertise, free installation, and after-sales support.",
"Top brands and premium quality for your family's home gym.",
"Tailored solutions for every fitness level and family space.",
"Convenient and secure online shopping with fast delivery.",
"Building a healthier, active lifestyle for the whole family."
  ];

  const { data: banners, isLoading: bannersLoading } = GetBanner();
  const { data, isLoading } = HomeBannerimage_3();
  console.log(data,"data")
  const {
    data: blogData,
    isLoading: blogsLoading
  } = GetBlog();

  const pgainatedData =
    (blogData?.pages && blogData.pages?.[blogData?.pages?.length - 1]) || [];

  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <Box sx={{ py: 4, px: 2 ,paddingLeft: { lg: "5%", md: "5%", sm: "5%", xs: "5%" },
    paddingRight: { lg: "5%", md: "8%", sm: "5%", xs: "5%" },}}>
      {/* Why Choose Us Section */}
      <Grid container spacing={4} alignItems="center" sx={{ mb: 6 }}>
        <Grid item xs={12} md={6}>
        
            <img
              src={`${Bannerimages}/${data?.[0].image}`}
              // src="https://ap-supplero.myshopify.com/cdn/shop/files/img-5_59de2091-52aa-4ae6-b0cc-0d45c18d45be.png?v=1661497497"
              alt="Gym workout"
              style={{
                width: "100%",
                 minHeight: "450px",
                objectFit: "cover",
              }}
            />
     
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2 ,
            fontFamily: "CamptonBook",textAlign:'left'
          }}>
            Why Choose Us
          </Typography>
          <Typography variant="body1" sx={{  mb: 3,fontFamily: "CamptonBook", textAlign:'left'}}>
        
            As the Middle East's premier fitness equipment provider, we offer premium home gym equipment with free installation. Enjoy a seamless experience, secure online shopping, and reliable after-sales service. Build your family's home gym with high-quality brands and local expertise. Start your wellness journey today.

          </Typography>

          <Box sx={{ mb: 3 }}>
            {features.map((feature, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  py: 2,
                  borderTop: index === 0 ? "none" : "1px solid #e0e0e0",
                }}
              >
                <CheckCircleIcon sx={{ color: "#4caf50", mr: 2 }} />
                <Typography variant="body1" sx={{ fontWeight: 500, fontFamily: "CamptonBook", textAlign:'left' }}>
                  {feature}
                </Typography>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>

      {/* Banner Images */}
      <Grid container spacing={3} sx={{ mb: 6 }}>
        {
        !bannersLoading &&
          Array.isArray(banners) &&
          banners.slice(0, 2).map((curElem) => (
            <Grid item xs={12} md={6} key={curElem.id}>
              <CardMedia
                component="img"
                // height="250"
                src={`${Bannerimages}/${curElem.image}`}
                sx={{ borderRadius: 2 }}
                alt={curElem.title}
              />
            </Grid>
          ))}
      </Grid>
      <Otherproducts product="featured" />
      {/* Blog Section */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: 4 ,
          fontFamily: "CamptonBook",
        }}>
          From Our Blog
        </Typography>
      </Box>

      <Grid container spacing={3} >

{pgainatedData?.blogs?.length > 0 &&
  pgainatedData.blogs.slice(0, 3).map((curElem) => {
    const slug = convertToSlug(curElem.title);

    return (
      <Grid item xs={12} sm={6} md={4} lg={4} key={curElem.id}>
        <Link
          to={`/blog/${slug}`}
          state={{ id: curElem.id }}
          className="link"
          style={{ textDecoration: 'none' }}
        >
          {/* <Card className="list_body_all_offerzoone" sx={{ height: '100%' }}>
            <LazyLoadImage
              src={`https://ik.imagekit.io/thmmwwbpc/blog/images/${curElem.image}`}
              alt={curElem.title}
              className="blog_image_list"
              effect="blur"
            />
            <CardContent
              sx={{
                maxHeight: 90,
                minHeight: 90,
                padding: 0,
              }}
            >
              <p className="flbrandtxt1">
                By admin on {moment(curElem?.updated_at).format('MMM Do YY')}
              </p>
              <p
                className="flbrand_blog"
                dangerouslySetInnerHTML={{
                  __html: curElem.title,
                }}
              />
            </CardContent>
          </Card> */}








<Card sx={{ height: '100%', borderRadius: 2, overflow: 'hidden' }}>
   
                <LazyLoadImage
                                    
                                    src={`https://ik.imagekit.io/thmmwwbpc/blog/images/${curElem.image}`}
                                    alt="blogimag1"
                                    className="blog_image_list"
                                  />
          <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            <Box
              sx={{
                bgcolor: '#fbbf24',
                color: 'white',
                px: 1,
                py: 2,
                borderRadius: 1,
                fontSize: '0.75rem',
                fontWeight: 'bold',
                writingMode: 'vertical-rl',
                textOrientation: 'mixed',
                minWidth: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
           
              {moment(curElem?.updated_at).format('MMM Do YY')}
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle" sx={{ fontWeight: 600 ,alignItems:'left'}}>
                {curElem.title}
              </Typography>
       <p className="flbrandtxt1">
                By admin on {moment(curElem?.updated_at).format('MMM Do YY')}
              </p>
           
            </Box>
          </CardContent>
        </Card>













        </Link>
      </Grid>
    );
  })}
       {/* {
          pgainatedData &&
              pgainatedData?.blogs?.map((curElem) => {
                const Text = curElem.title;
                console.log(
                  curElem,
                  "curElem.created_at"
                );
    return (
      <Grid item xs={12} md={4} key={curElem.id}>
        <Card sx={{ height: '100%', borderRadius: 2, overflow: 'hidden' }}>
          <CardMedia
            component="img"
            height="200"
            image={curElem.image}
            alt={curElem.title}
          />
          <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            <Box
              sx={{
                bgcolor: '#fbbf24',
                color: 'white',
                px: 1,
                py: 2,
                borderRadius: 1,
                fontSize: '0.75rem',
                fontWeight: 'bold',
                writingMode: 'vertical-rl',
                textOrientation: 'mixed',
                minWidth: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {curElem.date}
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {curElem.title}
              </Typography>

           
            </Box>
          </CardContent>
        </Card>
      </Grid>
    );
  })
} */}

      </Grid>
    </Box>
  );
};

export default WhyChooseUs;
